/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { darken, math } from 'polished';
import { ResetText } from './mixins/_reset-text.mixin';
import { FontSize } from './vendor/_rfs.mixin';
import { BorderRadius, BorderTopRadius } from './mixins/_border-radius.mixin';
import { BoxShadow } from './mixins/_box-shadow.mixin';
import { subtract } from './_functions';

export default ($) => {

  const bsPopoverTop = css`
    margin-bottom: ${$.popoverArrowHeight};

    > .arrow {
      bottom: ${subtract(math(`-${$.popoverArrowHeight}`), $.popoverBorderWidth)};

      &::before {
        bottom: 0;
        border-width: ${$.popoverArrowHeight} ${math(`${$.popoverArrowWidth} * 0.5`)} 0;
        border-top-color: ${$.popoverArrowOuterColor};
      }

      &::after {
        bottom: ${$.popoverBorderWidth};
        border-width: ${$.popoverArrowHeight} ${math(`${$.popoverArrowWidth} * 0.5`)} 0;
        border-top-color: ${$.popoverArrowColor};
      }
    }
  `;

  const bsPopoverRight = css`
    margin-left: ${$.popoverArrowHeight};

    > .arrow {
      left: ${subtract(math(`-${$.popoverArrowHeight}`), $.popoverBorderWidth)};
      width: ${$.popoverArrowHeight};
      height: ${$.popoverArrowWidth};
      margin: ${$.popoverBorderRadius} 0;

      &::before {
        left: 0;
        border-width: ${math(`${$.popoverArrowWidth} * 0.5`)} ${$.popoverArrowHeight} ${math(`${$.popoverArrowWidth} * 0.5`)} 0;
        border-right-color: ${$.popoverArrowOuterColor};
      }

      &::after {
        left: ${$.popoverBorderWidth};
        border-width: ${math(`${$.popoverArrowWidth} * 0.5`)} ${$.popoverArrowHeight} ${math(`${$.popoverArrowWidth} * 0.5`)} 0;
        border-right-color: ${$.popoverArrowColor};
      }
    }
  `;

  const bsPopoverBottom = css`
    margin-top: ${$.popoverArrowHeight};

    > .arrow {
      top: ${subtract(math(`-${$.popoverArrowHeight}`), $.popoverBorderWidth)};

      &::before {
        top: 0;
        border-width: 0 ${math(`${$.popoverArrowWidth} * 0.5`)} ${$.popoverArrowHeight} ${math(`${$.popoverArrowWidth} * 0.5`)};
        border-bottom-color: ${$.popoverArrowOuterColor};
      }

      &::after {
        top: ${$.popoverBorderWidth};
        border-width: 0 ${math(`${$.popoverArrowWidth} * 0.5`)} ${$.popoverArrowHeight} ${math(`${$.popoverArrowWidth} * 0.5`)};
        border-bottom-color: ${$.popoverArrowColor};
      }
    }
  `;

  const bsPopoverLeft = css`
    margin-right: ${$.popoverArrowHeight};

    > .arrow {
      right: ${subtract(math(`-${$.popoverArrowHeight}`, $.popoverBorderWidth))};
      width: ${$.popoverArrowHeight};
      height: ${$.popoverArrowWidth};
      margin: ${$.popoverBorderRadius} 0;

      &::before {
        right: 0;
        border-width: ${math(`${$.popoverArrowWidth} * 0.5`)} 0 ${math(`${$.popoverArrowWidth} * 0.5`)} ${$.popoverArrowHeight};
        border-left-color: ${$.popoverArrowOuterColor};
      }

      &::after {
        right: ${$.popoverBorderWidth};
        border-width: ${math(`${$.popoverArrowWidth} * 0.5`)} 0 ${math(`${$.popoverArrowWidth} * 0.5`)} ${$.popoverArrowHeight};
        border-left-color: ${$.popoverArrowColor};
      }
    }
  `;

  return css`
    .popover {
      position: absolute;
      top: 0;
      left: 0;
      z-index: ${$.zindexPopover};
      display: block;
      max-width: ${$.popoverMaxWidth};
      ${new ResetText().include($)};
      ${new FontSize($.popoverFontSize).include($)};
      word-wrap: break-word;
      background-color: ${$.popoverBg};
      background-clip: padding-box;
      border: ${$.popoverBorderWidth} solid ${$.popoverBorderColor};
      ${new BorderRadius($.popoverBorderRadius).include($)};
      ${new BoxShadow($.popoverBoxShadow).include($)};

      .arrow {
        position: absolute;
        display: block;
        width: ${$.popoverArrowWidth};
        height: ${$.popoverArrowHeight};
        margin: 0 ${$.popoverBorderRadius};

        &::before,
        &::after {
          position: absolute;
          display: block;
          content: "";
          border-color: transparent;
          border-style: solid;
        }
      }
    }

    .bs-popover-top { ${bsPopoverTop}; }
    .bs-popover-right { ${bsPopoverRight}; }
    .bs-popover-bottom { ${bsPopoverBottom}; }
    .bs-popover-left { ${bsPopoverLeft}; }

    .bs-popover-auto {
      &[x-placement^="top"] {
        ${bsPopoverTop}
      }
      &[x-placement^="right"] {
        ${bsPopoverRight}
      }
      &[x-placement^="bottom"] {
        ${bsPopoverBottom}
      }
      &[x-placement^="left"] {
        ${bsPopoverLeft}
      }
    }

    .popover-header {
      padding: ${$.popoverHeaderPaddingY} ${$.popoverHeaderPaddingX};
      margin-bottom: 0;
      ${new FontSize($.fontSizeBase).include($)};
      color: ${$.popoverHeaderColor};
      background-color: ${$.popoverHeaderBg};
      border-bottom: ${$.popoverBorderWidth} solid ${darken(0.05, $.popoverHeaderBg)};
      ${new BorderTopRadius($.popoverInnerBorderRadius).include($)};

      &:empty {
        display: none;
      }
    }

    .popover-body {
      padding: ${$.popoverBodyPaddingY} ${$.popoverBodyPaddingX};
      color: ${$.popoverBodyColor};
    }
  `;
}